import { z } from "zod";
import {
  FORM_TIME_EDGES_SECONDS,
  INTERACTION_ACTIONS,
  INTERACTION_AREAS,
} from "./interaction-vocabulary";

export * from "./interaction-vocabulary";

/**
 * Interactions (ADR 0016; docs/admin-app/figures.md › Interactions): what only the browser knows,
 * counted by the web app for users who share usage statistics. A fixed vocabulary of counts:
 * never an item's id, text, a field's value, a URL or a finer time than the batch.
 */

/**
 * What the web app sends, about once a minute: counts only. Unlike the report it is strict, since
 * the browser and the server run the same version: anything else in it is refused.
 */
export const interactionBatchSchema = z.strictObject({
  counts: z
    .array(
      z.strictObject({
        area: z.enum(INTERACTION_AREAS),
        action: z.enum(INTERACTION_ACTIONS),
        /** For a form's save or cancel: the bucket of how long it was open (`formTimeBucket`). */
        formSeconds: z.union(FORM_TIME_EDGES_SECONDS.map((edge) => z.literal(edge))).optional(),
        count: z.int().min(1).max(10_000),
      }),
    )
    .max(200),
});
export type InteractionBatch = z.infer<typeof interactionBatchSchema>;

/** A batch as day counts: `ui.<area>.<action>`, with the form time bucket as the value. */
export function interactionCounts(batch: InteractionBatch): [string, string, number][] {
  return batch.counts.map(({ area, action, formSeconds, count }) => [
    `ui.${area}.${action}`,
    formSeconds === undefined ? "" : String(formSeconds),
    count,
  ]);
}
